import { MODEL_NAME, DESCRIPTION } from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { routes } from "@/routes/utils";
import { schema } from "./validations";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";

const AddEdit = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "Property Model",
    moduleRoute: `${routes.masterData}/${routes.propertyModel}`,
    schema,
    defaultValues: { [MODEL_NAME]: "", [DESCRIPTION]: "" },
    nameFieldKey: MODEL_NAME,
    queryKeyToInvalidate: "property-models",
    module: "property-models",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Model Name"
    />
  );
};

export default AddEdit;
